<template>
  <div class="home">
    <CompanyList v-show="listView" @newCompany="onClickNewFromList" @editCompany="onClickEditFromList" ref="refreshList"/>
    <CompanyForm v-show="formView" :company="company" @backClicked="onBackChild" @backParentID="backParentID"/>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import CompanyList from '@/components/company/CompanyList.vue'
import CompanyForm from '@/components/company/CompanyForm.vue'
import { getHeader, companyUrl } from '../config'

export default {
  name: 'Company',
  components: {
    CompanyList,
    CompanyForm
  },
  data () {
    return {
      listView: true,
      formView: false,
      company: {
        id: null,
        company_no: null,
        name: null,
        address: null,
        phone: null,
        npwp: null,
        email: null,
        logo: null,
        accounts: [{
          id: null,
          alias: null,
          company_no: null,
          bank_id: null,
          bank_account: null,
          bank_address: null,
          bank_account_name: null,
          notes: null,
          billing_no: null,
          type: null
        }]
      }
    }
  },
  methods: {
    backParentID: function (id) {
      axios.get(companyUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.company = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    onClickEditFromList: function (value) {
      this.listView = false
      this.formView = true
      this.company = value
    },
    getEdit: function (value) {
      console.log(companyUrl + '/' + value)
      axios.get(companyUrl + '/' + value, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.listView = false
          this.formView = true
          this.company = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      this.listView = false
      this.formView = true
      this.company = {
        id: null,
        company_no: null,
        name: null,
        address: null,
        phone: null,
        npwp: null,
        email: null,
        logo: null,
        accounts: [{
          alias: null,
          company_no: null,
          bank_id: null,
          bank_account: null,
          bank_address: null,
          bank_account_name: null,
          notes: null,
          billing_no: null,
          type: null
        }]
      }
    },
    onBackChild: function () {
      this.listView = true
      this.formView = false
      this.company = {
        id: null,
        company_no: null,
        name: null,
        address: null,
        phone: null,
        npwp: null,
        email: null,
        logo: null,
        accounts: [{
          id: null,
          alias: null,
          company_no: null,
          bank_id: null,
          bank_account: null,
          bank_address: null,
          bank_account_name: null,
          notes: null,
          billing_no: null,
          type: null
        }]
      }
      this.$refs.refreshList.refreshList()
      // this.$router.replace({ path: 'sales', query: null })
    }
  },
  mounted () {
    this.$store.dispatch('getBankList')
  }
}
</script>
